import React, { Suspense } from 'react';

import MostPopularArticlesHeader from '@components/MostPopularArticles/Header';
import Spinner from '@components/Spinner';
import GraphicsSearchPageSearchBar from '@components/pages/Graphics/SearchPage/Search';

import GraphicsPageRelatedItem from './RelatedItem';
import { RIGHT_RAIL_TITLE } from './constants';
import type { GraphicsPageRightRailProps } from './interfaces';

const GraphicsPageRightRail = ({
  handleSearchTermChange,
  relatedGraphics = [],
  searchQuery,
}: GraphicsPageRightRailProps) => {
  return (
    <aside className="relative mt-80 flex-shrink-0 print:hidden md:mt-0 md:w-[195px] lg:w-[260px]">
      <div className="md:sticky md:top-80">
        <GraphicsSearchPageSearchBar
          searchQuery={searchQuery}
          setSearchQuery={handleSearchTermChange}
          isCompact
        />

        {relatedGraphics?.length > 0 && (
          <Suspense fallback={<Spinner />}>
            <article className="mt-80 md:mt-112">
              <MostPopularArticlesHeader title={RIGHT_RAIL_TITLE} />
              <ul className="m-0 list-none p-0">
                {relatedGraphics.map((graphic) => (
                  <GraphicsPageRelatedItem
                    key={graphic.id}
                    publishDate={graphic.publishDate}
                    title={graphic.title}
                    url={graphic.url}
                  />
                ))}
              </ul>
            </article>
          </Suspense>
        )}
      </div>
    </aside>
  );
};

export default GraphicsPageRightRail;
